import * as React from 'react'

export const AlignRightIcon = React.memo(
  ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={className} {...props}>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.2891 5.83398C17.2891 5.48881 17.0092 5.20898 16.6641 5.20898H3.33073C2.98555 5.20898 2.70573 5.48881 2.70573 5.83398C2.70573 6.17916 2.98555 6.45898 3.33073 6.45898H16.6641C17.0092 6.45898 17.2891 6.17916 17.2891 5.83398ZM17.2891 10.0007C17.2891 9.65547 17.0092 9.37565 16.6641 9.37565H7.4974C7.15222 9.37565 6.8724 9.65547 6.8724 10.0007C6.8724 10.3458 7.15222 10.6257 7.4974 10.6257H16.6641C17.0092 10.6257 17.2891 10.3458 17.2891 10.0007ZM17.2891 14.1673C17.2891 13.8221 17.0092 13.5423 16.6641 13.5423H12.4974C12.1522 13.5423 11.8724 13.8221 11.8724 14.1673C11.8724 14.5125 12.1522 14.7923 12.4974 14.7923H16.6641C17.0092 14.7923 17.2891 14.5125 17.2891 14.1673Z" fill="currentColor"/>
</svg>
    )
  },
)

AlignRightIcon.displayName = 'AlignRightIcon'
